<template>
  <ul>
    <li
      v-for="item in menu.items"
      :key="item.title"
      class="mt-2 first-of-type:mt-0"
    >
      <NuxtLink
        :to="item.href ? localePath(item.href) : `#${item.anchor}`"
        class="flex cursor-pointer select-none items-center gap-2 border-2 border-transparent py-2.5 px-3 outline-none transition-all duration-150 ease-in-out hover:border-shade-900 focus:border-shade-900 focus:shadow-md focus:ring-0 active:shadow-md"
        :class="item.isActive ? 'shadow-md border-shade-900' : ''"
      >
        <BasicIcon
          v-if="item.resourceIcon"
          :type="item.resourceIcon"
          class="h-6 w-6"
        />
        <span class="first-letter:uppercase">{{ $t(item.title) }}</span>
      </NuxtLink>
      <ul v-if="item.children" class="h-full w-full">
        <li v-for="subitem in item.children" :key="subitem.title">
          <NuxtLink
            :to="subitem.href ? localePath(subitem.href) : `#${subitem.anchor}`"
            class="inline-block w-full cursor-pointer select-none border-2 border-transparent py-2.5 pr-3 pl-11 outline-none transition-all duration-150 ease-in-out first-letter:uppercase hover:border-shade-900 focus:border-shade-900 focus:shadow-md focus:ring-0 active:shadow-md"
            :class="item.isActive ? 'shadow-md border-shade-900' : ''"
          >
            {{ subitem.title }}
          </NuxtLink>
          <ul v-if="subitem.children" class="h-full w-full">
            <li v-for="subsubitem in subitem.children" :key="subsubitem.title">
              <NuxtLink
                :to="
                  subitem.href
                    ? localePath(subsubitem.href)
                    : `#${subsubitem.anchor}`
                "
                class="inline-block w-full cursor-pointer select-none border-2 border-transparent py-2.5 pr-3 pl-20 outline-none transition-all duration-150 ease-in-out first-letter:uppercase hover:border-shade-900 focus:border-shade-900 focus:shadow-md focus:ring-0 active:shadow-md"
                :class="subsubitem.isActive ? 'shadow-md border-shade-900' : ''"
              >
                {{ subsubitem.title }}
              </NuxtLink>
              <ul v-if="subsubitem.children" class="h-full w-full">
                <li
                  v-for="subsubsubitem in subsubitem.children"
                  :key="subsubsubitem.title"
                >
                  <NuxtLink
                    :to="
                      subsubsubitem.href
                        ? localePath(subsubsubitem.href)
                        : `#${subsubsubitem.anchor}`
                    "
                    class="inline-block w-full cursor-pointer select-none border-2 border-transparent py-2.5 pr-3 pl-28 outline-none transition-all duration-150 ease-in-out first-letter:uppercase hover:border-shade-900 focus:border-shade-900 focus:shadow-md focus:ring-0 active:shadow-md"
                    :class="
                      subsubsubitem.isActive ? 'shadow-md border-shade-900' : ''
                    "
                  >
                    {{ subsubsubitem.title }}
                  </NuxtLink>
                </li>
              </ul>
            </li>
          </ul>
        </li>
      </ul>
    </li>
  </ul>
</template>
<script lang="ts" setup>
import { PropType } from 'vue'
const localePath = useLocalePath()
const props = defineProps({
  menu: {
    type: Object as PropType<SidebarMenu>,
    required: true,
  },
})
</script>
